export default constantObject => {

    let list = [];

    for (const key of Object.keys(constantObject)) {

        if (!isNaN(key)) {
            
            list.push({
                value: Number(key),
                label: constantObject[key]
            });

        };

    };

    return list;

}